<svg width="2" height="4" viewBox="0 0 2 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 0C1.16421 0 1.5 0.3358 1.5 0.75V3.25C1.5 3.66422 1.16421 4 0.75 4C0.335786 4 0 3.66422 0 3.25V0.75C0 0.3358 0.335786 0 0.75 0Z" fill="black"/>
</svg>
